import { Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { LoginpageComponent } from './loginpage/loginpage.component';
import { NotfoundComponent } from './notfound/notfound.component';
import { authguardGuard } from './guards/authguard.guard';

export const routes: Routes = [
  { path: '', component: LoginpageComponent },
  
  {
    path: 'admin',
    loadComponent: () => import('./adminhome/adminhome.component').then(m => m.AdminhomeComponent),
    children: [
      {
        path: '',
        loadComponent: () => import('./admin/admin.component').then(m => m.AdminComponent),
        canActivate: [authguardGuard]
      },
      {
        path: 'link', 
        loadComponent: () => import('./createlink/createlink.component').then(m => m.CreateLinkComponent), 
        canActivate: [authguardGuard]
      },
      {
        path: ':id',
        loadComponent: () => import('./details/details.component').then(m => m.DetailsComponent),
        canActivate: [authguardGuard]
      },
    ],
    canActivate: [authguardGuard]
  },
  
  { path: 'forgot', loadComponent: () => import('./forgot/forgot.component').then(m => m.ForgotComponent) },
  { path: 'reset', loadComponent: () => import('./reset/reset.component').then(m => m.ResetComponent) },
  { path: 'error', component: NotfoundComponent },
  { path: ':id', component: HomeComponent },
];
